import { z } from "zod";

const toText = (value) => {
  if (value == null) return "";
  if (typeof value === "number") return String(value);
  return value;
};

const requiredText = (label) =>
  z.preprocess(
    toText,
    z
      .string({ required_error: `${label} is required` })
      .trim()
      .min(1, `${label} is required`)
  );

export const RentersStep4Schema = z.object({
  liabilityLimit: requiredText("Liability limit"),
  medicalPaymentsLimit: requiredText("Medical payments limit"),
  deductible: requiredText("Deductible"),
  theftSublimit: requiredText("Theft sublimit"),
  homeComputerCoverage: requiredText("Home computer coverage"),
  paymentPlan: requiredText("Payment plan"),
  runClue: z.boolean().default(false),
});
